import { render, staticRenderFns } from "./ModalUpdateQueue.vue?vue&type=template&id=08f9983c&"
import script from "./ModalUpdateQueue.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdateQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports